module.exports = __webpack_public_path__ + "img/J.d883a3c1.png";